import { useEffect, useState } from "react";

export default function ConsultantDashboard() {
  const consultantId = localStorage.getItem("consultant_id");

  const [consultant, setConsultant] = useState(null);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    fetchDashboard();
  }, []);

  const fetchDashboard = async () => {
    try {
      const res = await fetch(
        `/api/consultant/dashboard/${consultantId}`
      );

      const data = await res.json();
      setConsultant(data.consultant);
      setOrders(data.orders || []);
    } catch (err) {
      console.error(err);
    }
  };

  const toggleOnlineStatus = async () => {
    try {
      const res = await fetch(
        "/api/consultant/toggle-online",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            consultant_id: consultantId,
          }),
        }
      );

      const data = await res.json();
      alert(data.msg);
      fetchDashboard();
    } catch (err) {
      console.error(err);
    }
  };

  if (!consultant) {
    return <div className="p-10">加载中...</div>;
  }

  return (
    <div>
      <h1 className="text-3xl font-bold mb-8">
        欢迎回来，{consultant.name}
      </h1>

      {/* 数据卡片 */}
      <div className="grid md:grid-cols-4 gap-5 mb-8">
        <div className="bg-purple-50 rounded-xl p-5 shadow">
          <p className="text-gray-500">综合评分</p>
          <h3 className="text-2xl font-bold">⭐ {consultant.rating}</h3>
        </div>

        <div className="bg-pink-50 rounded-xl p-5 shadow">
          <p className="text-gray-500">总订单</p>
          <h3 className="text-2xl font-bold">{consultant.total_orders}</h3>
        </div>

        <div className="bg-blue-50 rounded-xl p-5 shadow">
          <p className="text-gray-500">好评率</p>
          <h3 className="text-2xl font-bold">{consultant.good_rate}%</h3>
        </div>

        <div className="bg-green-50 rounded-xl p-5 shadow">
          <p className="text-gray-500">单次价格</p>
          <h3 className="text-2xl font-bold">¥{consultant.price}</h3>
        </div>
      </div>

      {/* 在线状态 */}
      <div className="bg-gray-50 rounded-xl p-6 mb-8">
        <h3 className="text-xl font-bold mb-4">接单状态</h3>

        <p className="mb-4">
          当前状态：
          {consultant.is_online ? (
            <span className="text-green-500 font-bold"> 在线接单</span>
          ) : (
            <span className="text-red-500 font-bold"> 暂停接单</span>
          )}
        </p>

        <button
          onClick={toggleOnlineStatus}
          className={`px-6 py-2 rounded-lg text-white ${
            consultant.is_online
              ? "bg-red-400 hover:bg-red-500"
              : "bg-green-500 hover:bg-green-600"
          }`}
        >
          {consultant.is_online ? "暂停接单" : "开始接单"}
        </button>
      </div>

      {/* 最近订单 */}
      <div>
        <h3 className="text-xl font-bold mb-4">最近订单</h3>

        {orders.length === 0 ? (
          <p className="text-gray-400">暂无订单</p>
        ) : (
          <div className="space-y-3">
            {orders.map((order) => (
              <div
                key={order.id}
                className="border rounded-xl p-4 flex justify-between"
              >
                <div>
                  <p>订单号：{order.id}</p>
                  <p>价格：¥{order.price}</p>
                </div>
                <div>
                  <p>{order.status}</p>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}